import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

export function FinanceViewToggle({ value, onChange }) {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(_, v) => v && onChange(v)}
      size="small"
    >
      <ToggleButton value="commercial">Comercial</ToggleButton>
      <ToggleButton value="fiscal">Fiscal</ToggleButton>
    </ToggleButtonGroup>
  );
}
